import { HisBasic } from "./HisBasic";


export class GovRow {
  健檢日期: string = "";
  公司編號: string = "";
  作業編號: string = "";
  身份證號: string = "";

  問題類別: string = "";
  問題編號: string = "";
  答題內容: string = "";

  答題內容_1: string = "";// 限40字元內 ， 填入該題第一個遇到的文字
  答題內容_2: string = "";// 限40字元內
  答題內容_3: string = "";// 限40字元內
  答題內容_4: string = "";// 限40字元內

  constructor(基本檔: HisBasic, 問卷類別: string) {
    this.健檢日期 = 基本檔.檢查日期;
    this.公司編號 = 基本檔.公司編號;
    this.作業編號 = 基本檔.作業編號;
    this.身份證號 = 基本檔.身份證號;

    this.問題類別 = 問卷類別;
  }

}
